<template>
    <v-card width="350px" style="position: absolute; top: 50%; left:50%; transform: translate(-50%, -50%);" class="pa-3">
      <v-card-text>
        <v-row>
          <v-col align="center" class="text-h4 pb-6">
            Login
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-text-field v-model="username" v-on:keyup.enter="login" hide-details outlined label="Benutzername" class="my-2"></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <v-text-field 
              v-on:keyup.enter="login"
              v-model="password" 
              hide-details 
              outlined 
              label="Passwort" 
              class="my-2"     
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showPassword = !showPassword"></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="red--text" align="center">
            <span v-if="error">
              Der Benutzername oder das Passwort ist falsch!
            </span>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-btn class="mt-2" color="primary" @click="login">Login</v-btn>
          <v-spacer></v-spacer>
        </v-row>
      </v-card-text>
    </v-card>
</template>

<script>
import Cookies from 'js-cookie'
import axios from 'axios'

export default {
  name: 'LoginView',

  components: {},
  data: () => ({
    username: "",
    password: "",
    showPassword: false,
    error: false,
  }),
  methods: {
    async login() {
      this.error = false;
      try {
        const res = await axios.post("/api/login", {
          username: this.username,
          password: this.password,
        });
        if (res.data.success) {
          Cookies.set("session", true)
          Cookies.set("user", this.username.toLowerCase().trim())
          Cookies.set("is_admin", res.data.is_admin ? "true" : "false")
          this.$store.state.user = this.username.toLowerCase().trim()
          this.$store.state.isAdmin = res.data.is_admin
          this.$router.push("home")
        }
      } catch {
        this.error = true;
      }
    }
  },
  mounted() {
    const cookie = Cookies.get("session")
    if (cookie) {
      this.$router.push("home")
    }
  }
}
</script>

<style>
</style>